import React from 'react';

export const ModalCommencer = ({text}) => {
	return (
		<div className="modal fade px-0 show" id="commencerReferent" aria-labelledby="commencerReferentLabel" aria-modal="true" role="dialog" >
			<div className="modal-dialog container-press px-2">
				<div className="modal-content rounded">
					<div className="modal-body">
						<h1 className="h1 text-primary font-weight-bolder ls-n1 lh-copy mb-0 mt-4 mt-lg-auto lh-title" id="commencerReferentLabel">Information</h1>
						<p className="lh-base font-weight-normal mt-3 mb-5">{text}</p>
						<div className="block mt-4 mt-lg-auto text-right">
							<button type="button" className="btn btn-light" data-dismiss="modal">Fermer</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}